import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import {SketchPicker} from "react-color";
import reactCSS from 'reactcss'
import {sleep} from "./AddBrandModal";
import Moment from "moment";
import { apiFetch, API, getMarket } from "../../services/api";


export default class AddHomeAdvertisingSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPickerText: false,
            displayColorPickerButton: false,
            homeAppeareanceImg: "",
            desktopHomeAppeareanceImg: "",
        };
        this.uploadHomeAppearanceImg = this.uploadHomeAppearanceImg.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }


    handleClickText = () => {
        this.setState({ displayColorPickerText: !this.state.displayColorPickerText })
    };

    handleCloseColorText = () => {
        this.setState({ displayColorPickerText: false })
    };


    uploadHomeAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "apperance/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.image = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadDesktopHomeAppearanceImg(e, slide) {

        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "apperance/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.desktopImage = result.message
                sleep(1000)
                this.setState({desktopHomeAppeareanceImg:  result.message});
            }))}
    }


    handleClose() {
        var products = []
        if(this.props.selectedSlide.products){
            this.props.selectedSlide.products.map(item =>{
                if (item.shortURL  && item.shortURL != ""){
                    products.push(item.shortURL)
                }
            })
            if (products.length == 0){
                products = this.props.selectedSlide.products
            }
        }

        this.props.selectedSlide.products = products
        this.props.selectedSlide.language = getMarket()

        apiFetch(API.back + '/advertising', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.props.selectedSlide)
        })
            .then( () => (
                this.props.closeModal,
                window.location.reload(false)))
            .catch( err =>
                console.log(err)
            );
    }

    render(){
        if(this.props.selectedSlide.order == -1){
            this.props.selectedSlide.order = 1000;
        }
        this.props.selectedSlide.type = this.props.headCategory;

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une publicité</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Titre : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedSlide.title = e.target.value} defaultValue={this.props.selectedSlide.title} placeholder="Ex : Home 1"/>
                                        </Form.Group>

                                        <Form.Group >
                                            <Form.Label>(Mobile) Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-first-img-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => {this.uploadHomeAppearanceImg(e, this.props.selectedSlide)}}
                                                custom
                                            />
                                            {this.props.selectedSlide.image ?
                                                <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedSlide.image}/>
                                                :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>(Ordinateur) Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-first-img-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => {this.uploadDesktopHomeAppearanceImg(e, this.props.selectedSlide)}}
                                                custom
                                            />
                                            {this.props.selectedSlide.desktopImage ?
                                                <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedSlide.desktopImage}/>
                                                :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Contraste : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => this.props.selectedSlide.contrast = e.target.value}
                                                defaultValue={this.props.selectedSlide.contrast}
                                            >
                                                <option value="0">0</option>
                                                <option value="0.1">0.1</option>
                                                <option value="0.2">0.2</option>
                                                <option value="0.3">0.3</option>
                                                <option value="0.4">0.4</option>
                                                <option value="0.5">0.5</option>
                                                <option value="0.6">0.6</option>
                                                <option value="0.7">0.7</option>
                                                <option value="0.8">0.8</option>
                                                <option value="0.9">0.9</option>
                                                <option value="1">1</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Date de début : </Form.Label>
                                            <Form.Control key="beginDate" type="datetime-local" name="begin" placeholder="Début"
                                                          defaultValue={Moment(this.props.selectedSlide.beginDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                          onChange={(e) => this.props.selectedSlide.beginDate = new Date(e.target.value).toISOString()}
                                            />                                        
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Date de fin : </Form.Label>
                                            <Form.Control key="endDate" type="datetime-local" name="begin" placeholder="Début"
                                                          defaultValue={Moment(this.props.selectedSlide.endDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                          onChange={(e) => this.props.selectedSlide.endDate = new Date(e.target.value).toISOString()}
                                            />                                        
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Texte : </Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => this.props.selectedSlide.subtitle = e.target.value} defaultValue={this.props.selectedSlide.subtitle} placeholder="Cette chaussure est ..."/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Lien : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedSlide.url = e.target.value} defaultValue={this.props.selectedSlide.url} placeholder="Ex : https://therunningcollective.fr/"/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Type de produit : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                multiple
                                                onChange={(e) => this.props.selectedSlide.shopTypeNG = [...e.target.selectedOptions].map(o => o.value)}
                                                defaultValue={this.props.selectedSlide.shopTypeNG}
                                            >
                                                <option key="athletisme" value="athletisme">Athlétisme</option>
                                                <option key="running" value="running">Running</option>
                                                <option key="trail" value="trail">Trail</option>
                                                <option key="home" value="home">Accueil du site</option>
                                            </Form.Control>
                                        </Form.Group>                                     
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

function getSelectedItems(items){
    var arrayToReturn = []

    if (items) {
        items.map(item =>(
                arrayToReturn.push(item)
            )
        )
    }

    return arrayToReturn
}